<template>


    <div id="source_choice"
	v-if="okanMap.SourcesWindow.visible">

		<!--<div id="source_choice_overlay" class="overlay"
		v-on:click="okanMap.SourcesWindow.visible = false;"></div>-->

        <div id="source_choice_window">

			<div id="close_source_choice" class="close_light"
			v-on:click="okanMap.SourcesWindow.datasetView = false; okanMap.SourcesWindow.visible = false;">

			</div>

			<!-- ##################################### -->
			<!-- ###          DATASET VIEW	       ### -->
			<!-- ##################################### -->
			<div id="source_providers" v-if="okanMap.SourcesWindow.datasetView == false">
				<div 
				v-for="(sourceprovider, indexSourceProvider) in okanMap.sourceProviders"
				v-bind:key="indexSourceProvider"
				class="source_provider" 
				v-bind:class="{
					['disabled'] : sourceprovider.datasets.length == 0
				}"
				v-on:click="showDatasets(sourceprovider)"
				>
					<img v-bind:src="sourceprovider.logo" />
				</div>
			</div>

			<div id="source_datasets" v-if="okanMap.SourcesWindow.datasetView">
				<div id="source_datasets_return"
				v-on:click="okanMap.SourcesWindow.datasetView = false"></div>

				<h3 class="title_window_source firsttitle">Datasets</h3>

				<div id="source_datasets_list">

					<div
					v-for="(provider, indexProvider) in getDatasets()"
					v-bind:key="indexProvider"
					class="source_dataset"
					v-bind:class="{
						['selected'] : okanMap.tmpSource.datasetId == provider.id
					}"
					v-on:click="selectDataset(provider.id)"
					>
						<h4>{{provider.name}}</h4>
						<p><small>{{provider.nb_points}} items</small></p>
					</div>
					

					<!--<div class="source_dataset" v-for="test in 100">test</div>-->

				</div>
				
			</div>
			<!-- ##################################### -->
			<!-- ###         /DATASET VIEW 	       ### -->
			<!-- ##################################### -->

			<div id="drag_file" v-show="okanMap.SourcesWindow.datasetView == false">
				<div class="drop_here"
				v-bind:class="{
					['dragover'] : dragover,
					['filesDropped'] : filesDropped,
				}"
				v-on:click="openFileSelection"
				v-on:dragover="onDragOver"
				v-on:dragleave="onDragLeave"
				v-on:drop="onDrop"
				ref="dropzone"
				>
					<div class="drop_text">
						<h3>Or Drag & Drop Your File(s) Here</h3>
						<p>.geojson only</p>
					</div>
					
				</div>
			</div>

        </div>

    </div>

		
</template>

<script>
import Source from '../models/Source.js'


export default {
	name: 'SourceManager',
	props: {
		okanMap : Object
	},
	data: function() {
		return {

			dragover: false,
			filesDropped:false

		}
	},
	mounted() {

		
		


	},
	created() {

		

	},
	destroyed() {

	},
	methods : {

		init() {
		},

		getSelectedDataset() {
			return this.okanMap.sourceProviders.find(x => x.id == this.okanMap.tmpSource.provider.id).datasets.find(dataset => dataset.id == this.okanMap.tmpSource.datasetId);
		},

		getDatasets() {
			return this.okanMap.sourceProviders.find(x => x.id == this.okanMap.tmpSource.provider.id).datasets;
		},

		showDatasets(provider) {

			if(provider.datasets.length > 0) { // only if there is something to show
				this.sourceFilterTmp = '';
				this.okanMap.tmpSource.provider = provider;
				this.okanMap.SourcesWindow.datasetView = true;
			}

		},

		selectDataset(idDataset) {

			this.okanMap.tmpSource.datasetId = idDataset;

			/*
			tmpSource = {
				provider : 1,
				datasetId : 2,
				name: 'Name',
				structure : [
                    'Latitude',
                    'Longitude',
                    'Name',
                    'AllowedPersons',
                    'Description',
                    'Creation date'
                ]
			}
			*/



			let currentDataset = this.getSelectedDataset();
			this.okanMap.tmpSource.name = currentDataset.name

			
				
			this.okanMap.dataManager.getDataFromSource(this.okanMap.tmpSource, (data) => {
				console.log('getting data from service...')
				var source = new Source();
				source.name = this.okanMap.tmpSource.name
				source.id = this.okanMap.uniqueIdNumber();
				source.providerId = this.okanMap.tmpSource.provider.id;
				source.datasetId = this.okanMap.tmpSource.datasetId;
				source.ready = true; 
				source.data = data;
				console.log(data);

				var propertiesList = []
				for(var attr in data.features[0].properties) {
					propertiesList.push(attr)
				}
				propertiesList.push('tick');
				source.structure = propertiesList;

				/*
				this.okanMap.dataManager.getDatasetStructure(this.okanMap.tmpSource, (datasetStruct) => {

					console.log('datasetStruct', datasetStruct);

					this.okanMap.tmpSource.structure = datasetStruct;

					

					this.okanMap.sources.push( source);

					console.log('adding new source', source)

					this.okanMap.SourcesWindow.datasetView = false; 
					this.okanMap.SourcesWindow.visible = false;
				})*/

				source.properties = this.okanMap.getSourceProperties(source)

				this.okanMap.sources.push( source);

				console.log('adding new source', source)

				this.okanMap.SourcesWindow.datasetView = false; 
				this.okanMap.SourcesWindow.visible = false;

				

			})
				

			



		},

		openFileSelection() {

		},
		onDragOver(e) {

			e.preventDefault();  
    		e.stopPropagation();

			this.dragover = true;

		},
		onDragLeave(e) {
			e.preventDefault();  
    		e.stopPropagation();
			this.dragover = false;
		},
		onDrop(e) {
			e.preventDefault();  
    		e.stopPropagation();
			
			this.filesDropped = true;



			var reader = new FileReader();

			reader.readAsText(e.dataTransfer.files[0]);
			var nameParams = e.dataTransfer.files[0].name.split('.');
			var ext = nameParams.pop();  

			console.log(nameParams)

			var filename = nameParams.shift();

			console.log(filename);

			if(filename.isArray) 
				filename = filename.join('_');

			console.log('ext', ext)
			console.log('filename', filename)


			reader.addEventListener('load',(event) => {
				var dataContent = event.target.result;

				var newFilesource = this.okanMap.dataManager.HandleNewFile(dataContent, ext, filename);

				if(newFilesource.success) {

					if(newFilesource.source.originalContentType == 'geojson') {
						let sources = this.okanMap.dataManager.splitSourceForTypes(newFilesource.source)

						sources.forEach((s) => {
							s.properties = this.okanMap.getSourceProperties(s)
							var propertiesList = []
							for(var attr in s.data.features[0].properties) {
								propertiesList.push(attr)
							}
							propertiesList.push('tick');
							s.structure = propertiesList;
							this.okanMap.sources.push(s)
							console.log('source added', s);
						})

						this.filesDropped = false;
						this.dragover = false;
						this.okanMap.datasetView = false;
						this.okanMap.SourcesWindow.visible = false;
					}
					else {
						console.log(newFilesource);
					}


					

					
				}
				else {
					alert('There is an error in your file')
					this.filesDropped = false;
					this.dragover = false;
					newFilesource = null;
				}

			},false);
		

		}

	}
}
</script>

<style scoped src="../assets/css/ui.css"></style>